import { Theme } from '@mui/material/styles';

import { paper, stylesMode, varAlpha } from '../styles/index.js';

// ----------------------------------------------------------------------

const MuiDrawer = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    paperAnchorRight: ({ ownerState, theme }: { ownerState: any; theme: Theme }) => ({
      ...(ownerState.variant === 'temporary' && {
        ...paper({ theme }),
        boxShadow: `-40px 40px 80px -8px ${varAlpha(
          (theme.palette.grey as any)['500Channel'],
          0.24
        )}`,
        [stylesMode.dark]: {
          boxShadow: `-40px 40px 80px -8px ${varAlpha(
            (theme.palette.common as any).blackChannel,
            0.24
          )}`,
        },
        [theme.breakpoints.up('xs')]: {
          width: '100%',
        },
        [theme.breakpoints.up('sm')]: {
          width: 300,
        },
        [theme.breakpoints.up('md')]: {
          width: 400,
        },
        [theme.breakpoints.up('lg')]: {
          width: 500,
        },
        [theme.breakpoints.up('xl')]: {
          width: 600,
        },
      }),
    }),
    paperAnchorLeft: ({ ownerState, theme }: { ownerState: any; theme: Theme }) => ({
      ...(ownerState.variant === 'temporary' && {
        ...paper({ theme }),
        boxShadow: `40px 40px 80px -8px ${varAlpha(
          (theme.palette.grey as any)['500Channel'],
          0.24
        )}`,
        [stylesMode.dark]: {
          boxShadow: `40px 40px 80px -8px  ${varAlpha(
            (theme.palette.common as any).blackChannel,
            0.24
          )}`,

          [theme.breakpoints.up('xs')]: {
            width: '100%',
          },
          [theme.breakpoints.up('sm')]: {
            width: 300,
          },
          [theme.breakpoints.up('md')]: {
            width: 400,
          },
          [theme.breakpoints.up('lg')]: {
            width: 500,
          },
          [theme.breakpoints.up('xl')]: {
            width: 600,
          },
        },
      }),
    }),
  },
};

// ----------------------------------------------------------------------

export const drawer = { MuiDrawer };
